var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[(_vm.$auth.isAuthenticated)?_c('HeaderLoggedIn'):_c('HeaderLoggedOut'),_vm._v(" "),_c('v-main',[_c('nuxt')],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }